import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import "../CSS/Global.css";

const TermsAndConditions = () => {
  return (
    <>
      <Header />
      <div className="legal-page-shell">
        <div className="terms-and-conditions legal-doc">
          <h1>Terms &amp; Conditions</h1>
          <p className="legal-doc-meta">
            <strong>Filmekee.com</strong> (“Filmekee”, “we”, “us”, “our”) is an online marketplace connecting customers with vendors offering equipment, services, and listings relevant to film, production, and creative projects. By accessing or using our website or mobile experience, you agree to these Terms &amp; Conditions.
          </p>

          <h2>1. Eligibility &amp; account</h2>
          <p>
            You must be legally able to enter contracts in your jurisdiction. You are responsible for account security and for all activity under your account. Information you provide must be accurate and kept up to date.
          </p>

          <h2>2. Marketplace role</h2>
          <p>
            Filmekee facilitates discovery, booking, payments, and communication between users and vendors. Unless stated otherwise on a specific listing, the contract for the goods or services is between you and the vendor. Filmekee is not the seller of inventory booked through vendor storefronts.
          </p>

          <h2>3. Bookings, pricing &amp; availability</h2>
          <p>
            Listings, prices, availability, and booking windows are set by vendors. A confirmed booking is subject to the vendor honouring the slot and terms shown at checkout. You agree to provide correct contact and booking details (including booking dates or ranges where applicable).
          </p>

          <h2>4. Cancellations</h2>
          <p>
            <strong>Cancellation window:</strong> You may request cancellation of a booking only if your request is received <strong>at least twelve (12) hours before</strong> the scheduled start time of that booking (or the start of the booked date range, as shown on your order). Requests received <strong>within twelve (12) hours</strong> of that start time are <strong>not accepted</strong>, and the booking will remain chargeable as placed.
          </p>
          <p>
            <strong>Cancellation fee:</strong> When we approve a cancellation made within the allowed window, a <strong>twenty percent (20%) cancellation fee</strong> applies to the eligible booking amount; the balance is processed according to our <Link to="/refund-policy">Refund Policy</Link>.
          </p>

          <h2>5. Vendor obligations</h2>
          <p>
            Vendors must comply with applicable laws, honour confirmed bookings, describe listings honestly, and maintain professional conduct on the platform. Filmekee may suspend or remove accounts or content that violate these terms or harm users.
          </p>

          <h2>6. Acceptable use</h2>
          <p>
            You will not misuse the platform (including fraud, harassment, attempting to pay off-platform to evade fees, scraping, or interfering with security). We may investigate and take action, including termination of access.
          </p>

          <h2>7. Intellectual property</h2>
          <p>
            Filmekee branding, software, and site content are protected. You retain rights to content you upload but grant us a licence to host and display it as needed to operate the service.
          </p>

          <h2>8. Limitation of liability</h2>
          <p>
            To the maximum extent permitted by law, Filmekee is not liable for indirect or consequential losses arising from use of the platform or third-party vendor performance. Our total liability for any claim relating to the service is limited to the platform fees we earned from your specific disputed transaction in the six (6) months before the claim, except where law does not allow such a cap.
          </p>

          <h2>9. Changes</h2>
          <p>
            We may update these terms; the “Last updated” date below will change. Continued use after updates constitutes acceptance of the revised terms where permitted by law.
          </p>

          <p>
            <strong>Last updated:</strong> 31 March 2026 · <strong>Contact:</strong> support@filmekee.com (replace with your live support channel when available).
          </p>
        </div>
      </div>
    </>
  );
};

export default TermsAndConditions;
